<script>
    import {createEventDispatcher} from "svelte";
    import {I_PEOPLE_TAG, people_tags} from "../stores/people_tags";
    import {objectifyArray} from "../../../../../lib/datatypes";
    import Tag from "./Tag.svelte";

    const dispatch = createEventDispatcher();

    export let tag_id_list = '';
    export let show_delete_buttons = false;

    // NB annoyingly `split` returns an array wrapped empty string if the tag_id_list === '' (rather than an
    // empty array, which would be ideal).. so, we have to filter for that case first, before then transforming
    // things if there are real ids in the string
    $: tags = tag_id_list.split(',').filter(id => {
        return id !== '';
    }).map(id => {
        id = id.trim();
        return objectifyArray(I_PEOPLE_TAG, $people_tags.lookup[id]);
    }).filter(tag => !tag.deleted);

    const onItemClicked = id => {
        dispatch('tagClicked', {id:id});
    }
    const onDeleteClicked = id => {
        dispatch('deleteClicked', {id:id});
    };
</script>

{#each tags as tag (tag.id)}
<Tag display_tag={tag} show_delete_button={show_delete_buttons} on:deleteClicked={(e) => onDeleteClicked(e.detail.id)}></Tag>
{/each}

<style></style>